import { numberWithCommas, toDiscount } from "../lib/assets";
const productData = window.productData;
const checkPickers = document.querySelectorAll(".check-picker");
const variantOptions = document.querySelector("variant-radios");
const radiosPickers = variantOptions.querySelectorAll(".pack-picker");
const atcButtonPrice = document.querySelector(".product-form__buttons .price__container");

checkPickers?.forEach((picker, idx) => {
	picker.addEventListener("click", (e) => {
		const inputPicker = picker
			.closest(".product-form__input")
			.querySelectorAll("input");

		inputPicker.forEach((picker) => picker.removeAttribute("checked"));

		const correspondingInput = [...inputPicker].find(
			(input) => input.value === e.currentTarget.dataset.value
		);
		if (correspondingInput) {
			correspondingInput.setAttribute("checked", "");

			const inputCheck = document.querySelectorAll(".product-form__input input[checked]");
			const packsPickerWrapper = document.querySelectorAll('.pack-picker .info-prices');
			const savingWrapper = document.querySelectorAll('.info-wrapper .option-label.mini');

			const optionsCurrents = [...inputCheck].map((element) => element.value);
			const [color, size] = optionsCurrents;

			const optionsValue = productData.filter((element) => {
				return element.option1 === color && element.option2 === size;
			});

			optionsValue.forEach((value, idx) => {

				const priceValue = value.price;
				const compareAtPrice = value.compare_at_price;

				const savingsPercentage = ((compareAtPrice - priceValue) / compareAtPrice) * 100;
				const savingsFixed =  compareAtPrice - priceValue;

				const packsPickerWrapperCompareAtPrice = packsPickerWrapper[idx].querySelector('s.price-item--regular');
				const packsPickerWrapperRegularPrice = packsPickerWrapper[idx].querySelector('span.price-item--last');

				const saving = savingWrapper[idx].querySelector('span');

				switch (savingStyle) {
					case 'save-%':
						if (compareAtPrice > priceValue) {
							saving.style.display = 'block'
							saving.innerHTML = `Ahorras ${toDiscount(savingsPercentage)}%`
						}else{
							saving.style.display = 'none'
						}
						break;
					case 'save-$':
						if (compareAtPrice > priceValue) {
							saving.style.display = 'block'
							saving.innerHTML = `Ahorras ${numberWithCommas(savingsFixed)}`
						}else{
							saving.style.display = 'none'
						}
						break;
				}

				packsPickerWrapperCompareAtPrice.innerHTML = numberWithCommas(compareAtPrice);
				packsPickerWrapperRegularPrice.innerHTML = numberWithCommas(priceValue);

				
			})

		}
	});
});


if (atcButtonPrice) {
	radiosPickers?.forEach((radio, idx) => {
		radio.addEventListener("click", (e) => {
			const atcPriceRegular = atcButtonPrice.querySelector("s.price-item--regular");
			const atcPriceOriginal = atcButtonPrice.querySelector("span.price-item--last");

			const itemPriceRegular = radio.querySelector("s.price-item--regular");
			const itemPriceOriginal = radio.querySelector("span.price-item--last");
			const priceRegularText = itemPriceRegular.innerText;
			const priceOriginalText = itemPriceOriginal.innerText;

			atcPriceRegular.innerHTML = priceRegularText;
			atcPriceOriginal.innerHTML = priceOriginalText;
		});
	});
}